import React, { Suspense, ExoticComponent } from "react";

import { TopLoader } from "../TopLoader";

const Loadable =
  (Component: ExoticComponent, isFallBack = true) =>
  (props: JSX.IntrinsicAttributes) =>
    (
      <Suspense fallback={isFallBack ? <TopLoader /> : undefined}>
        <Component {...props} />
      </Suspense>
    );

export default Loadable;
